import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const financialSubType = {
    name: "Financial Type",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose Financial Type(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Financial Type",
    },
    type: "input",
    category: "dashboard",
};
